import React from "react";
import { entityTypeNoun } from "../manage-workflows-helper";
import { EditableWorkflow } from "../types";
import { triggerStopReason, WorkflowBlueprint } from "./workflow-blueprint";

interface WorkflowStopRulesProps {
    workflow: EditableWorkflow;
    blueprint: WorkflowBlueprint | null;
}

export const WorkflowStopRules: React.FC<WorkflowStopRulesProps> = props => {
    const { workflow, blueprint } = props;
    const noun = entityTypeNoun(workflow.attachTo);
    const reason = blueprint ? triggerStopReason(blueprint) : null;

    return (
        <div>
            <h3 className="font-medium text-gray-900">Stops When</h3>
            <ul className="mt-2 list-disc pl-5 text-sm text-gray-600 space-y-1">
                {reason ? <li>{reason}</li> : null}
                <li>Someone stops the scheduled run from a {noun}&apos;s record</li>
                <li>You unpublish or delete this workflow</li>
            </ul>
        </div>
    );
};
